import config from "../config";
import { getAuthHeader, refreshAuthToken } from "../services/authToken";
const PatientConsultationResponse = async (params, onDone, apiUrl) => {
  let authHeader = getAuthHeader();
  if (!authHeader) {
    await refreshAuthToken();
    authHeader = getAuthHeader();
  }
  if (!authHeader) {
    throw new Error("Session expired. Please login again.");
  }
  const formData = new FormData();
  // Separate the PDF file and other payload
  const { pdfFile, payload } = params;
  formData.append("payload", JSON.stringify(payload));
  if (payload.actionName) formData.append("actionName", payload.actionName);
  if (payload.actionNumber)
    formData.append("actionNumber", payload.actionNumber);
  if (payload.isPerformed !== undefined)
    formData.append("isPerformed", payload.isPerformed.toString());
  if (payload.image !== undefined) formData.append("image", payload.image);
  if (payload.documentType !== undefined)
    formData.append("documentType", payload.documentType);
  if (payload.referralReference !== undefined)
    formData.append("referralReference", payload.referralReference);
  if (pdfFile) {
    formData.append("pdfFile", pdfFile, "referral-letter.pdf");
  }
  const response = await fetch(`${config.localurl}${apiUrl}`, {
    method: "POST",
    headers: {
      Authorization: authHeader,
    },
    body: formData,
  });

  if (!response.ok) throw new Error("Failed to call API");

  const result = await response.json();
  return result;
  // if (result.response === true) {
  //   if (onDone) onDone();
  //   setIncrementReferralCompleted(true);
  // } else {
  //   throw new Error("Operation failed");
  // }
};

export default PatientConsultationResponse;
